import { GrantContext } from './IAccessGrant';
import { ACCESS_GRANTS } from './registry';

export const isAccessGranted = (
  context: GrantContext,
  isToggleEnabled: (featureToggle: string) => boolean = () => true,
): boolean => {
  return ACCESS_GRANTS.some((grant) =>
    (grant.featureToggle ? isToggleEnabled(grant.featureToggle) : true)
    && grant.enabled
    && grant.match(context),
  );
};
